import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CMS_POST_API_CONFIG } from '../config';
import {
  SeriesBasePath,
  SeriesMetadata,
  UpsertSeriesMetadataRequest,
} from '../models/series-metadata.model';
import { ApiResponse } from '../models';

@Injectable({ providedIn: 'root' })
export class SeriesMetadataService {
  private readonly _http = inject(HttpClient);
  private readonly _apiBase: string;

  constructor() {
    const config = inject(CMS_POST_API_CONFIG);
    this._apiBase = `${config.apiBaseUrl}/api`;
  }

  upsertMetadata(
    basePath: SeriesBasePath,
    seriesId: string,
    payload: UpsertSeriesMetadataRequest,
  ): Observable<SeriesMetadata> {
    return this._http
      .patch<ApiResponse<SeriesMetadata>>(
        `${this._apiBase}/${basePath}/${seriesId}/metadata`,
        payload,
      )
      .pipe(map(res => res.data!));
  }

  getMetadata(
    basePath: SeriesBasePath,
    seriesId: string,
    orgId: string,
  ): Observable<SeriesMetadata | null> {
    const params = new HttpParams().set('orgId', orgId);
    return this._http
      .get<ApiResponse<SeriesMetadata | null>>(
        `${this._apiBase}/${basePath}/${seriesId}/metadata`,
        { params },
      )
      .pipe(map(res => res.data ?? null));
  }
}
